const fbq = window.fbq || ((...args) => console.debug(`fbq(${JSON.stringify(args)})`))

export const notifyFbAnalyticsAboutFinishedOrder = order => {
  fbq('track', 'Purchase', {
    value: order.data.total_amount_sum,
    currency: order.data.product_price_currency,
    content_type: order.data.product.categories_and_locations_string,
    contents: order.data.order_items.map(order_item => FbAnalyticsOrderItemData(order, order_item))
  });
}

export const FbAnalyticsOrderItemData = (order, order_item) => {
  return {
    quantity: order_item.quantity,
    id: order.product_variant_id,
    item_price: order_item.unit_price.value
  }
}


// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/lib/FbAnalyticsTools.js